import { render, staticRenderFns } from "./MostFrequentTopicTooltip.vue?vue&type=template&id=8809ed98&scoped=true"
import script from "./MostFrequentTopicTooltip.vue?vue&type=script&lang=js"
export * from "./MostFrequentTopicTooltip.vue?vue&type=script&lang=js"
import style0 from "./MostFrequentTopicTooltip.vue?vue&type=style&index=0&id=8809ed98&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8809ed98",
  null
  
)

export default component.exports